import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null); // null=checking, false=anon, {user, organizations, org, permissions, role}

  const loadOrg = useCallback(async (base) => {
    try {
      const { data } = await api.get("/org");
      return { ...base, org: data.data.org, membership: data.data.membership, permissions: data.data.permissions, role: data.data.membership.role };
    } catch {
      return { ...base, org: null, permissions: [], role: null };
    }
  }, []);

  const applySession = useCallback(async (payload) => {
    if (payload.access_token) localStorage.setItem("bl_token", payload.access_token);
    const full = await loadOrg({ user: payload.user, organizations: payload.organizations });
    setSession(full);
    return full;
  }, [loadOrg]);

  useEffect(() => {
    (async () => {
      if (!localStorage.getItem("bl_token")) return setSession(false);
      try {
        const { data } = await api.get("/auth/me");
        await applySession(data.data);
      } catch {
        localStorage.removeItem("bl_token");
        setSession(false);
      }
    })();
  }, [applySession]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("bl_token");
    setSession(false);
  };

  const refreshOrg = async () => setSession((s) => s && s); // placeholder for re-render
  const reloadOrg = async () => { if (session) setSession(await loadOrg(session)); };

  const can = (perm) => !!session && (session.permissions?.includes("*") || session.permissions?.includes(perm));

  return <AuthCtx.Provider value={{ session, applySession, logout, can, reloadOrg, refreshOrg }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
